export default __webpack_public_path__ + "static/ai-marketing-6-8adee0327b1ec10f4c1998436785db22.png";